import { UiSectionGroupModel } from "../../models";
import { renderViewModels } from "../../render-view-model";
import { BackgroundField } from "../../styles";

import { SectionGroup } from "./UiSectionGroup.styles";

type UiSectionGroupProps = {
    readonly model: UiSectionGroupModel;
};

const UiSectionGroup = ({
    model: {
        content: { sections, background }
    }
}: UiSectionGroupProps) => {
    return (
        <SectionGroup background={background as BackgroundField[]}>
            {renderViewModels(sections)}
        </SectionGroup>
    );
};

export default UiSectionGroup;
